import React, { useState } from "react";

import InputText from "@app/components/2_widgets/inputs/InputText";

import { useAuth } from '@app/contexts/AuthContext';
import { apiCall } from '@app/utils/apiCall';
import { useCustomer } from "@app/contexts/CustomerContext";


export default function DataPrevInputEdit({label, defaultValue, formKey, placeholder=""}) {
    const [value, setValue] = useState(defaultValue ? defaultValue : "");
    const [displayInput, setDisplayInput] = useState(defaultValue ? false : true);
    const auth = useAuth();
    const customer = useCustomer();

    function updateCustomer(newValue) {
        if (customer.id) {
            const formData = new FormData();

            formData.append('customer[id]', customer.id);
            formData.append(`customer[${formKey}]`, newValue); 
            
            apiCall({
                method: "patch",
                path: `/api/v1/customers/${customer.id}`,
                auth: auth,
                data: formData,
                onSuccess: (response) => {
                    setValue(newValue);
                }
            });
        }
    }

    function showInput() {
        if (displayInput) {
            return (
                <InputText
                    inputId={label}                
                    defaultValue={value}
                    placeholder={placeholder}
                    callbackOnChange={(newValue) => updateCustomer(newValue)}
                    callbackBlur={(error, value) => setDisplayInput(false)}
                />
            )            
        } else 
            return (
                <span className="editable" onClick={(e) => setDisplayInput(!displayInput)}>
                    {value}
                </span>
            )
    }

    return (
        <div className="row input-edit">
            <div className="col-2 gray-text">{label}</div>
            <div className="col-6">
                {showInput()}                
            </div>
        </div>
    )
}